<style lang="scss" src="./style.scss" scoped></style>
<script src="./script"></script>
<template>
  <article>
    <h5><span v-if="expirationSoon.length">{{$filters.comma(expirationSoon.length)}}</span> CPDs sắp hết hạn <span v-if="expirationSoon.length > 0">(<router-link class="text-primary" :to="'cpds?id=' + getCpdIds(expirationSoon)"><i
          class="fa fa-edit"></i> Xem chi tiết</router-link>)</span></h5>
    <overlay class="expiration-soon mt-3" :loading="isLoadingExpiration">
      <div class="table-responsive">
        <table class="table table-striped">
          <thead>
            <tr>
              <th></th>
              <th>Hiển thị</th>
              <th>Tên CPD</th>
              <th>Brand</th>
              <th>Key liên kết</th>
            </tr>
          </thead>
          <tbody>
            <tr v-for="(item, i) in expirationSoon" :key="i">
              <td>
                <div class="thumbnail thumbnail-sm"
                  :style="{ backgroundImage: `url(${$filters.getFileUrl((item.content.mobile || item.content.pc).src)})` }">
                  <div class="review">
                    <div><img :src="$filters.getFileUrl((item.content.mobile || item.content.pc).src)"></div>
                  </div>
                </div>
              </td>
              <td>
                <span class="text-success" v-if="item.display"><i class="fa fa-check-circle"></i> Đang bật</span>
                <span class="text-secondary" v-else><i class="fa fa-check-circle"></i> Đang tắt</span>
              </td>
              <td>{{ item.name }}</td>
              <td>{{ item.brand_name }}</td>
              <td><a :href="$filters.getExternalUrl(item)" target="_blank">{{ item.external_key }} <i
                    class='bx bx-link'></i></a>
              </td>
            </tr>

            <tr v-if="!isLoadingExpiration && expirationSoon.length == 0">
              <td colspan="5">Không có dữ liệu</td>
            </tr>
          </tbody>
        </table>
      </div>
  </overlay>
</article>
</template>